module.exports = __webpack_public_path__ + "img/money.17a153bb.svg";